/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useState } from 'react';
import _ from 'lodash';

import PropTypes from 'prop-types';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { AddressLookupService } from 'gw-capability-address';
import { MLGeoCompleteService } from 'ml-services-common-react';
import metadata from './MLPAVehicleGarageLocationComponent.metadata.json5';
import styles from './MLPAVehicleGarageLocationComponent.module.scss';


function MLPAVehicleGarageLocationComponent(props) {
    const { viewModel, policyState, headerLabel} = props;
    const { refreshData } = useDataRefresh();
    const [newCity, setnewCity] = useState();
    const [newState, setnewState] = useState();
    const [showCiyState, setShowCityState] = useState(false);
    const [showPOBoxError, setshowPOBoxError] = useState(false);
    const [showOutofStateError, setshowOutofStateError] = useState(false);
    const PoBoxRegExpression = '^(.*?)([Pp]\\.? ?[Oo]\\.? ?[Bb][Oo][Xx])(.*)$';
        
    const isParkedInStateSameAsPrimary = () => {        
        if (_.isEqual(viewModel.value.state, policyState)) {
            setshowOutofStateError(false);
        } else {
            setshowOutofStateError(true);
        }
    };

    const isPOBox = () => {
        const POBoxRegex = new RegExp(PoBoxRegExpression);
        if (POBoxRegex.test(viewModel.value.addressLine1)
            || POBoxRegex.test(viewModel.value.addressLine2)) {
            setshowPOBoxError(true);
        } else {
            setshowPOBoxError(false);
        }
    };
    
    const writeValue = (value, path) => {
        _.set(viewModel, path, value);
        if (path === 'addressLine1' || path === 'addressLine2') {
            isPOBox();
        }
        if (path === 'postalCode') {
            isParkedInStateSameAsPrimary();
        }
        if(path === 'city') {
            const city =  _.get(viewModel, 'city.value', '');
            value =   city || newCity;
        }
        refreshData();
    };

    const statesCallback = async ({ states: data, postalCode }) => {
        const { viewModel: addressData } = props;
        const newAddressData = _.clone(addressData.value);
        if (data && data.length === 1 && data[0].City && data[0].StateProvince) {
            newAddressData.city = data[0].City;
            newAddressData.state = data[0].StateProvince;
        } else {
            const lookUpParams = {
                postalCode: postalCode.substring(0, 5)
            };
            const lookUpPromise = await AddressLookupService.lookUpCityAndState(lookUpParams);
            newAddressData.city = lookUpPromise.city ? lookUpPromise.city : undefined;
            newAddressData.state = lookUpPromise.state ? lookUpPromise.state : undefined;
        }
        if (newAddressData.city && newAddressData.state) {
            setShowCityState(false);
            setnewCity(newAddressData.city);
            setnewState(newAddressData.state);
            _.set(viewModel, 'city', newAddressData.city);
            _.set(viewModel, 'state',newAddressData.state)
        } else {
            setShowCityState(true);
        }
        if (newAddressData.state && _.isEqual(newAddressData.state, policyState)) {
            setshowOutofStateError(false);
        } else {
            setshowOutofStateError(true);
        }

    };

    const postalCodeCallBack = async (postalCode) => {
        const { viewModel: addressData } = props;
        const newAddressData = _.clone(addressData.value);
        const lookUpParams = {
            postalCode: postalCode.substring(0, 5)
        };
        const lookUpPromise = await AddressLookupService.lookUpCityAndState(lookUpParams);
        newAddressData.city = lookUpPromise.city ? lookUpPromise.city : undefined;
        newAddressData.state = lookUpPromise.state ? lookUpPromise.state : undefined;
        if (newAddressData.city && newAddressData.state) {
            setShowCityState(false);
            setnewCity(newAddressData.city);
            setnewState(newAddressData.state);
            _.set(viewModel, 'city', newAddressData.city);
            _.set(viewModel, 'state',newAddressData.state)
        } else {
            setShowCityState(true);
        }
        if (newAddressData.state && _.isEqual(newAddressData.state, policyState)) {
            setshowOutofStateError(false);
        } else {
            setshowOutofStateError(true);
        }
    };

    const onSearchPostalCode = (evt, object) => {
        if (/^\d{5}(-\d{4})?$/.test(object.value)) {
            MLGeoCompleteService.getStates(object.value.substring(0, 5))
                .then((states) => {
                    statesCallback({ states });
                })
                .catch((error) => {
                    console.error(error);
                    postalCodeCallBack(object.value);
                });
        }
        isParkedInStateSameAsPrimary();
    };

    const constructCityStateCode = () => {
        const city = _.get(viewModel, 'city.value', '');
        const stateCode = _.get(viewModel, 'state.value.code', '');
        const readonlyCity = newCity || city;
        const readonlyState = newState || stateCode;
        return `${readonlyCity}, ${readonlyState}`;
    };

    const overrideProps = {
        addressLine1: {
            className: 'vertical-spacing-20',
            label: headerLabel,
            hideLabel: _.isUndefined(headerLabel)
        },
        addressLine2: {
            className: 'vertical-spacing-20'
        },
        postalCode: {
            onBlur: onSearchPostalCode,
            placeholder: '#####'
        },
        state: {
            visible: showCiyState,
        },
        city: {
            visible: showCiyState
        },
        readonlyCityStateCodeContainer: {
            visible: !showCiyState
        },
        readonlyCityState: {
            content: constructCityStateCode(),
            className: styles.mailingReadOnly
        },
        poBoxError: {
            visible: showPOBoxError
        },
        outofStateZipError: {
            visible: showOutofStateError
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={viewModel}
            overrideProps={overrideProps}
            onValueChange={writeValue}
            classNameMap={styles}
        />
    );
}

MLPAVehicleGarageLocationComponent.propTypes = {
    viewModel: PropTypes.shape({}).isRequired,
    headerLabel: PropTypes.string
};


MLPAVehicleGarageLocationComponent.defaultProps = {
    headerLabel: undefined
};


export default MLPAVehicleGarageLocationComponent;
